import { InjectionToken } from '@angular/core';

export const ICON_PATH_TOKEN = new InjectionToken<string>('ICON_PATH_TOKEN');
